export enum ETableRemoveType {
	single = 'single',
	multi = 'multi'
}